import { getAccessReadable } from "@/appInterface/windows/shareWindow/shareWindowHelpers";
import type {
    AdditionalData,
    AdditionalDataProjectMode,
    Member,
} from "@/appInterface/windows/shareWindow/types";

export function applyUserTemplate(
    member: Member,
    state: string,
    mode: "board" | "project",
    additionalData: AdditionalData,
) {
    // пустая строка для search режима
    const access = getAccessReadable(member.access);

    // search отображение
    let demoModeClass = "";
    if (state === "search") {
        demoModeClass = "shareWindowPeopleListItemSearch";
    }

    // прячем toggle у owner
    // project share и board share открываются только если у пользователя owner || edit
    let readOnlyToggleClass = "";
    if (member.access === "owner" || (mode === "project" && additionalData.myAccess === "view")) {
        readOnlyToggleClass = "unionAccessToggleReadOnly";
    }

    return `
        <div class="shareWindowPeopleListItem ${demoModeClass}" memberId="${member.memberId}" memberName="${member.name}" memberEmail="${member.email}">
            <div class="shareWindowPeopleListItemLogo">${member.name.charAt(0).toUpperCase()}</div>
            <div class="shareWindowPeopleListItemInfo">
                <div class="shareWindowPeopleListItemInfoName">${member.name}</div>
                <div class="shareWindowPeopleListItemInfoEmail">${member.email}</div>
            </div>
            <div class="shareWindowPeopleListItemSpacer"></div>
            <div class="shareWindowPeopleListItemToggle unionAccessToggle ${readOnlyToggleClass}" reason="memberAccess">
                <div class="shareWindowPeopleListItemToggleInfo unionAccessToggleName">${access}</div>
                <svg class="svg" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" style="/* color: white; *//* fill: white; */"><path d="M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z" fill-rule="evenodd" fill-opacity="1" fill="black" stroke="none"></path></svg>
            </div>
            <div class="shareWindowPeopleListItemEmail">${member.email}</div>
        </div>
    `;
}

export function getMenuTemplate(searchAccess: string) {
    return `
            <div class="shareWindow">

                <div class="shareWindowTop"></div>

                <div class="shareWindowSearch">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="User / User_Add">
                        <path id="Vector" d="M15 19C15 16.7909 12.3137 15 9 15C5.68629 15 3 16.7909 3 19M19 16V13M19 13V10M19 13H16M19 13H22M9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8C13 10.2091 11.2091 12 9 12Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                    <div class="shareWindowSearchField">
                        <input autocomplete="off" class="shareWindowSearchFieldInput" type="text" placeholder="">
                    </div>
                    <div class="shareWindowSearchToggle unionAccessToggle" reason="searchAccess">
                        <div class="shareWindowSearchToggleInfo unionAccessToggleName">${searchAccess}</div>
                        <div class="shareWindowSearchToggleIcon">
                            <svg class="svg" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" style="/* color: white; *//* fill: white; */"><path d="M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z" fill-rule="evenodd" fill-opacity="1" fill="black" stroke="none"></path></svg>
                        </div>
                    </div>
                </div>

                <div class="shareWindowShareAdditional"></div>

                <div class="shareWindowPeople">
                    <div class="shareWindowPeopleTitle">Настройка доступа</div>
                    <div class="shareWindowPeopleList scrollable"></div>
                </div>

                <div class="shareWindowActions">
                    <div class="shareWindowActionsItem shareWindowActionsItemAction"></div>
                    <div class="shareWindowActionsItem shareWindowActionsItemMinor"></div>
                </div>
            </div>
        `;
}

export function getBoardShareAdditionalTemplate(teamName: string) {
    return `
        <div class="shareWindowShareAdditionalMore">
            <div class="shareWindowShareAdditionalMoreOption">
                <div class="shareWindowShareAdditionalMoreOptionIcon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="User / Users">
                        <path id="Vector" d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
                <div class="shareWindowShareAdditionalMoreOptionTitle">Все в команде <span>${teamName}</span></div>
                <div class="shareWindowShareAdditionalMoreOptionToggle unionAccessToggle" reason="teamAccess">
                    <div class="shareWindowShareAdditionalMoreOptionToggleInfo shareWindowShareAdditionalMoreOptionToggleInfoTeam unionAccessToggleName">Редактор</div>
                    <svg class="svg" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" style="/* color: white; *//* fill: white; */"><path d="M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z" fill-rule="evenodd" fill-opacity="1" fill="black" stroke="none"></path></svg>
                </div>
            </div>

            <div class="shareWindowShareAdditionalMoreOption">
                <div class="shareWindowShareAdditionalMoreOptionIcon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Environment / Planet">
                        <path id="Vector" d="M6.89761 18.1618C8.28247 19.3099 10.0607 20 12.0001 20C16.4184 20 20.0001 16.4183 20.0001 12C20.0001 11.431 19.9407 10.8758 19.8278 10.3404M6.89761 18.1618C5.12756 16.6944 4.00014 14.4789 4.00014 12C4.00014 7.58172 7.58186 4 12.0001 4C15.8494 4 19.0637 6.71853 19.8278 10.3404M6.89761 18.1618C8.85314 17.7147 11.1796 16.7828 13.526 15.4281C16.2564 13.8517 18.4773 12.0125 19.8278 10.3404M6.89761 18.1618C4.46844 18.7171 2.61159 18.5243 1.99965 17.4644C1.36934 16.3726 2.19631 14.5969 3.99999 12.709M19.8278 10.3404C21.0796 8.79041 21.5836 7.38405 21.0522 6.46374C20.5134 5.53051 19.0095 5.26939 16.9997 5.59929" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
                <div class="shareWindowShareAdditionalMoreOptionTitle">Доступ по ссылке</div>
                <div class="shareWindowShareAdditionalMoreOptionToggle unionAccessToggle" reason="publicAccess">
                    <div class="shareWindowShareAdditionalMoreOptionToggleInfo shareWindowShareAdditionalMoreOptionToggleInfoLink unionAccessToggleName">Редактор</div>
                    <svg class="svg" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" style="/* color: white; *//* fill: white; */"><path d="M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z" fill-rule="evenodd" fill-opacity="1" fill="black" stroke="none"></path></svg>
                </div>
                <div class="shareWindowShareAdditionalMoreOptionSpacer"></div>
                <div class="shareWindowShareAdditionalMoreOptionPass"></div>
            </div>
        </div>
    `;
}

export function getSearchAdditionalTemplate() {
    return `<div class="shareWindowShareAdditionalBubbles"></div>`;
}

export function applySearchBubbleTemplate(candidateName: string, candidateEmail: string) {
    return `
        <div class="shareWindowShareAdditionalBubblesItem" candidateEmail="${candidateEmail}">
            <div class="shareWindowShareAdditionalBubblesItemLogo">${candidateName.charAt(0).toUpperCase()}</div>
            <div class="shareWindowShareAdditionalBubblesItemName">${candidateName}</div>
            <div class="shareWindowShareAdditionalBubblesItemClose">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Menu / Close_MD">
                    <path id="Vector" d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18" stroke="grey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </svg>
            </div>
        </div>
    `;
}

export function getProjectShareTopTemplate(additionalData: AdditionalDataProjectMode) {
    let isReadonly = "";
    if (additionalData.myAccess === "view") {
        isReadonly = "readonly";
    }
    return `
        <div class="shareWindowTopProject">
            <div class="shareWindowTopProjectAbout">Название проекта</div>
            <div class="shareWindowTopProjectName">
                <div class="shareWindowTopProjectNameField">
                    <input ${isReadonly} type="text" class="shareWindowTopProjectNameFieldInput" placeholder="Название проекта" value="${additionalData.projectName}">
                </div>
            </div>
        </div>
    `;
}

export function getPasswordChangeTemplate() {
    return `
        <div class="shareWindowShareAdditionalMoreOptionPassChange">
            <div class="shareWindowShareAdditionalMoreOptionPassChangeAction">Изменить пароль</div>
            <div class="shareWindowShareAdditionalMoreOptionPassChangeDelete">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Interface / Trash_Full">
                <path id="Vector" d="M14 10V17M10 10V17M6 6V17.8C6 18.9201 6 19.4798 6.21799 19.9076C6.40973 20.2839 6.71547 20.5905 7.0918 20.7822C7.5192 21 8.07899 21 9.19691 21H14.8031C15.921 21 16.48 21 16.9074 20.7822C17.2837 20.5905 17.5905 20.2839 17.7822 19.9076C18 19.4802 18 18.921 18 17.8031V6M6 6H8M6 6H4M8 6H16M8 6C8 5.06812 8 4.60241 8.15224 4.23486C8.35523 3.74481 8.74432 3.35523 9.23438 3.15224C9.60192 3 10.0681 3 11 3H13C13.9319 3 14.3978 3 14.7654 3.15224C15.2554 3.35523 15.6447 3.74481 15.8477 4.23486C15.9999 4.6024 16 5.06812 16 6M16 6H18M18 6H20" stroke="#5f5f5f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="
                    color: #5f5f5f;
                "></path>
                </g>
                </svg>
            </div>
        </div>
    `;
}

export function getPasswordEditorTemplate() {
    return `
        <div class="shareWindowShareAdditionalMoreOptionPassEdit">
            <form autocomplete="off">
                <input type="password" autocomplete="new-password" class="shareWindowShareAdditionalMoreOptionPassEditInput">
            </form>
            <div class="shareWindowShareAdditionalMoreOptionPassEditItem shareWindowShareAdditionalMoreOptionPassEditItemApply">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Interface / Check">
                <path id="Vector" d="M6 12L10.2426 16.2426L18.727 7.75732" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
                </svg>
            </div>
            <div class="shareWindowShareAdditionalMoreOptionPassEditItem shareWindowShareAdditionalMoreOptionPassEditItemClose">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Menu / Close_MD">
                <path id="Vector" d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
                </svg>
            </div>
        </div>
    `;
}

export function getPasswordAddTemplate() {
    return `
        <div class="shareWindowShareAdditionalMoreOptionPassAdd">
            <div class="shareWindowShareAdditionalMoreOptionPassAddIcon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Interface / Lock">
                <path id="Vector" d="M9.23047 9H7.2002C6.08009 9 5.51962 9 5.0918 9.21799C4.71547 9.40973 4.40973 9.71547 4.21799 10.0918C4 10.5196 4 11.0801 4 12.2002V17.8002C4 18.9203 4 19.4801 4.21799 19.9079C4.40973 20.2842 4.71547 20.5905 5.0918 20.7822C5.5192 21 6.07902 21 7.19694 21H16.8031C17.921 21 18.48 21 18.9074 20.7822C19.2837 20.5905 19.5905 20.2842 19.7822 19.9079C20 19.4805 20 18.9215 20 17.8036V12.1969C20 11.079 20 10.5192 19.7822 10.0918C19.5905 9.71547 19.2837 9.40973 18.9074 9.21799C18.4796 9 17.9203 9 16.8002 9H14.7689M9.23047 9H14.7689M9.23047 9C9.10302 9 9 8.89668 9 8.76923V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V8.76923C15 8.89668 14.8964 9 14.7689 9" stroke="#0b99ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
                </svg>
            </div>
            <div class="shareWindowShareAdditionalMoreOptionPassAddInfo">Установить пароль</div>
        </div>
    `;
}
